import { cn } from "admin-ui/utils/cn"

import { IconProps } from "."

export default function ImportIcon({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M13.8002 10.95C13.6102 10.95 13.4202 10.88 13.2702 10.73C12.9802 10.44 12.9802 9.96 13.2702 9.67L21.4702 1.47C21.7602 1.18 22.2402 1.18 22.5302 1.47C22.8202 1.76 22.8202 2.24 22.5302 2.53L14.3302 10.73C14.1902 10.87 14.0002 10.95 13.8002 10.95Z"
        fill="currentColor"
      />
      <path
        d="M17.83 11.75H13C12.59 11.75 12.25 11.41 12.25 11V6.17C12.25 5.76 12.59 5.42 13 5.42C13.41 5.42 13.75 5.76 13.75 6.17V10.25H17.83C18.24 10.25 18.58 10.59 18.58 11C18.58 11.41 18.24 11.75 17.83 11.75Z"
        fill="currentColor"
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
